import { DismissingCard } from '../DismissingCard/index.js';
import { MarkdownParser } from '../MarkdownParser/index.js';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { MarketingHeader, LargeImage, Image } from './styles.js';
import { BackgroundColorKeyMap, TextColorKeyMap } from './utils/colorKeyMap.js';

const MarketingCard = ({ className , imageUrl , bodyTemplate , actions , onDismiss =()=>void 0 , hasLargeImage , colorFunction , hasCircleDismissButton , dismissedText ="" , undoButtonText =""  })=>{
    const theme = useContext(ThemeContext);
    const Img = hasLargeImage ? LargeImage : Image;
    const circleButtonPosition = useMemo(()=>{
        if (hasLargeImage) {
            return {
                top: 24,
                right: 24
            };
        }
        if (!imageUrl) {
            return {
                top: 8,
                right: 8
            };
        }
        return undefined;
    }, [
        hasLargeImage,
        imageUrl
    ]);
    return /*#__PURE__*/ React.createElement(DismissingCard, {
        className: className,
        onDismiss: onDismiss,
        hasCircleButton: hasCircleDismissButton,
        dismissedText: dismissedText || "",
        undoButtonText: undoButtonText,
        circleButtonPosition: circleButtonPosition,
        hasTimeout: true,
        backgroundColor: colorFunction ? theme.colors[BackgroundColorKeyMap[colorFunction]] : theme.colors.ElementBackground,
        borderColor: colorFunction ? theme.colors[BackgroundColorKeyMap[colorFunction]] : theme.colors["Level 1"]
    }, imageUrl && /*#__PURE__*/ React.createElement(MarketingHeader, null, /*#__PURE__*/ React.createElement(Img, {
        src: imageUrl,
        alt: "MarketingImage"
    })), /*#__PURE__*/ React.createElement(MarkdownParser, {
        titleColor: colorFunction ? theme.colors[TextColorKeyMap[colorFunction]] : theme.colors.Foreground,
        paragraphColor: colorFunction ? theme.colors[TextColorKeyMap[colorFunction]] : theme.colors["Level 5"]
    }, bodyTemplate), /*#__PURE__*/ React.createElement(React.Fragment, null, actions));
};

export { MarketingCard };
